const Contact = () => {

    const testreq = async() => {
        const test = await fetch('/test').then(data => data.json())
        console.log(test)
    }
    testreq()
    return ( 
        <div className="contact-box">
        </div>
     );
}
 
export default Contact;